import { useEffect } from 'react';
import { registerReloadBlocker } from '../services/pwa/reload-gate';

/** While `blocked` is true, automatic update reloads are deferred. */
export function useReloadBlocker(blocked: boolean): void {
  useEffect(() => {
    if (!blocked) {
      return;
    }
    return registerReloadBlocker(() => true);
  }, [blocked]);
}
